// extracted by mini-css-extract-plugin
module.exports = {"container":"vxR2Avqg","slideInTop":"NzXDYQV8","leaving":"laW8Ua5N","slideOutTop":"_7_L6FY4K","avatar":"dgAB9MaI","name":"z2Y6aQrj","id":"rt9u2_Mi"};